// components
import GridPageAbstract from '../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../utils/gridHeadStorage';
import { GATEWAY_WALLET_DIRECTION } from '../../constants/gatewayWalletDirection';

// Money the gateway's owner puts on one of their cards (gateway_to_wallet) or
// takes off it (wallet_to_gateway): that wallet's takings go up or down, in the
// gateway's currency, and the gateway's balance does not move. It is how a
// gateway with no payins gets money to pay out with. The wallet must be the
// chosen gateway's, and the backend refuses a change that would leave the card
// with less than nothing available (TRIGGER_WALLET_TRANSFER_EXCEEDS_TAKINGS),
// including deleting a top-up whose money was spent.
export default class GatewayWalletTransfersPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'accountingGatewayWalletTransfers';
        this.Server = this.props.context.getState().server.accountingGatewayWalletTransfers;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['uuid', 'note'];

        const defaultHead = [
            { id: 'uuid', label: 'uuid', alignRight: false, cell: 'Text', displayGrid: true, disableEditor: true },
            {
                id: 'gatewayId', required: true,
                label: 'gateway',
                alignRight: false,
                cell: 'Select',
                from: 'publicGateways',
                object: 'gateway',
                show: 'name',
                displayGrid: true
            },
            {
                id: 'walletId', required: true,
                label: 'wallet',
                alignRight: false,
                cell: 'Select',
                from: 'publicWallets',
                object: 'wallet',
                show: 'uuid',
                helperText: 'gatewayWalletTransferWallet',
                displayGrid: true
            },
            {
                id: 'direction', required: true,
                label: 'direction',
                alignRight: false,
                cell: 'Items',
                items: GATEWAY_WALLET_DIRECTION,
                enumGroup: 'gatewayWalletDirection',
                helperText: 'gatewayWalletTransferDirection',
                displayGrid: true
            },
            // In the gateway's currency, the one takings are in, which the backend
            // stamps on the row as its currency.
            {
                id: 'amount', required: true,
                label: 'amount',
                alignRight: true,
                cell: 'Amount',
                currencyObject: 'currency',
                helperText: 'walletTransferAmount',
                displayGrid: true
            },
            { id: 'note', label: 'note', alignRight: false, cell: 'BigText', displayGrid: true },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'modifiedBy',
                label: 'modifiedBy',
                alignRight: false,
                cell: 'Select',
                object: 'modifiedBy',
                show: 'firstName+lastName',
                displayGrid: true,
                disableEditor: true,
                customSort: 'modifiedBy.firstName'
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
